// tslint:disable
/**
 * Projecto API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function RequestFromJSON(json) {
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'requestID': !exists(json, 'requestID') ? undefined : json['requestID'],
        'propertyID': !exists(json, 'propertyID') ? undefined : json['propertyID'],
        'requestTitle': !exists(json, 'requestTitle') ? undefined : json['requestTitle'],
        'requestNum': !exists(json, 'requestNum') ? undefined : json['requestNum'],
        'manager': !exists(json, 'manager') ? undefined : json['manager'],
        'managerEmail': !exists(json, 'managerEmail') ? undefined : json['managerEmail'],
        'requestDescription': !exists(json, 'requestDescription') ? undefined : json['requestDescription'],
        'location1': !exists(json, 'location1') ? undefined : json['location1'],
        'location2': !exists(json, 'location2') ? undefined : json['location2'],
        'requesterName': !exists(json, 'requesterName') ? undefined : json['requesterName'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'plannedYear': !exists(json, 'plannedYear') ? undefined : json['plannedYear'],
        'requesterDept': !exists(json, 'requesterDept') ? undefined : json['requesterDept'],
        'requesterPhone': !exists(json, 'requesterPhone') ? undefined : json['requesterPhone'],
        'requesterEmail': !exists(json, 'requesterEmail') ? undefined : json['requesterEmail'],
        'systemQuestion1': !exists(json, 'systemQuestion1') ? undefined : json['systemQuestion1'],
        'systemQuestion2': !exists(json, 'systemQuestion2') ? undefined : json['systemQuestion2'],
        'systemQuestion3': !exists(json, 'systemQuestion3') ? undefined : json['systemQuestion3'],
        'fundingSource': !exists(json, 'fundingSource') ? undefined : json['fundingSource'],
        'requestDate': !exists(json, 'requestDate') ? undefined : new Date(json['requestDate']),
        'targetStartDate': !exists(json, 'targetStartDate') ? undefined : new Date(json['targetStartDate']),
        'targetEndDate': !exists(json, 'targetEndDate') ? undefined : new Date(json['targetEndDate']),
        'requestType': !exists(json, 'requestType') ? undefined : json['requestType'],
        'affectedDepartment': !exists(json, 'affectedDepartment') ? undefined : json['affectedDepartment'],
        'requestCompletion': !exists(json, 'requestCompletion') ? undefined : new Date(json['requestCompletion']),
        'requestCompletionReason': !exists(json, 'requestCompletionReason') ? undefined : json['requestCompletionReason'],
        'estimatedCost': !exists(json, 'estimatedCost') ? undefined : json['estimatedCost'],
        'estimatedCostSource': !exists(json, 'estimatedCostSource') ? undefined : json['estimatedCostSource'],
        'projectSizeSF': !exists(json, 'projectSizeSF') ? undefined : json['projectSizeSF'],
        'escalationPct': !exists(json, 'escalationPct') ? undefined : json['escalationPct'],
        'internalCostsPct': !exists(json, 'internalCostsPct') ? undefined : json['internalCostsPct'],
        'requestedAmount': !exists(json, 'requestedAmount') ? undefined : json['requestedAmount'],
        'fundingSourceUnknown': !exists(json, 'fundingSourceUnknown') ? undefined : json['fundingSourceUnknown'],
        'requestFundID': !exists(json, 'requestFundID') ? undefined : json['requestFundID'],
        'requestFundName': !exists(json, 'requestFundName') ? undefined : json['requestFundName'],
        'requestCostCenter': !exists(json, 'requestCostCenter') ? undefined : json['requestCostCenter'],
        'executiveSponsor': !exists(json, 'executiveSponsor') ? undefined : json['executiveSponsor'],
        'fundedWithRestrictedFunds': !exists(json, 'fundedWithRestrictedFunds') ? undefined : json['fundedWithRestrictedFunds'],
        'fundedWithPresidentsContingency': !exists(json, 'fundedWithPresidentsContingency') ? undefined : json['fundedWithPresidentsContingency'],
        'webFlag': !exists(json, 'webFlag') ? undefined : json['webFlag'],
        'spentAsOfDate': !exists(json, 'spentAsOfDate') ? undefined : new Date(json['spentAsOfDate']),
    };
}
export function RequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'requestID': value.requestID,
        'propertyID': value.propertyID,
        'requestTitle': value.requestTitle,
        'requestNum': value.requestNum,
        'manager': value.manager,
        'managerEmail': value.managerEmail,
        'requestDescription': value.requestDescription,
        'location1': value.location1,
        'location2': value.location2,
        'requesterName': value.requesterName,
        'priority': value.priority,
        'plannedYear': value.plannedYear,
        'requesterDept': value.requesterDept,
        'requesterPhone': value.requesterPhone,
        'requesterEmail': value.requesterEmail,
        'systemQuestion1': value.systemQuestion1,
        'systemQuestion2': value.systemQuestion2,
        'systemQuestion3': value.systemQuestion3,
        'fundingSource': value.fundingSource,
        'requestDate': value.requestDate === undefined ? undefined : value.requestDate.toISOString(),
        'targetStartDate': value.targetStartDate === undefined ? undefined : value.targetStartDate.toISOString(),
        'targetEndDate': value.targetEndDate === undefined ? undefined : value.targetEndDate.toISOString(),
        'requestType': value.requestType,
        'affectedDepartment': value.affectedDepartment,
        'requestCompletion': value.requestCompletion === undefined ? undefined : value.requestCompletion.toISOString(),
        'requestCompletionReason': value.requestCompletionReason,
        'estimatedCost': value.estimatedCost,
        'estimatedCostSource': value.estimatedCostSource,
        'projectSizeSF': value.projectSizeSF,
        'escalationPct': value.escalationPct,
        'internalCostsPct': value.internalCostsPct,
        'requestedAmount': value.requestedAmount,
        'fundingSourceUnknown': value.fundingSourceUnknown,
        'requestFundID': value.requestFundID,
        'requestFundName': value.requestFundName,
        'requestCostCenter': value.requestCostCenter,
        'executiveSponsor': value.executiveSponsor,
        'fundedWithRestrictedFunds': value.fundedWithRestrictedFunds,
        'fundedWithPresidentsContingency': value.fundedWithPresidentsContingency,
        'webFlag': value.webFlag,
        'spentAsOfDate': value.spentAsOfDate === undefined ? undefined : value.spentAsOfDate.toISOString(),
    };
}
